<template>
  <div>
    <h1 class="thank-you-text">Your request is being processed...</h1>
    <loading :active.sync="isLoading"
             :is-full-page="fullPage"/>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import moment from 'moment'

export default {
  name: 'MobilePaySuccess',

  components: {
    Loading
  },

  data () {
    return {
      isLoading: false,
      fullPage: true,
      interval: null,
      counter: 0
    }
  },

  mounted () {
    const id = this.$route.query.id
    const type = this.$route.query.type
    const operation = this.$route.query.op

    this.isLoading = true

    if (operation === 'payment') {
      const self = this

      if (process.env.NODE_ENV === 'development') {
        this.interval = setInterval(function () {
          self.counter++
          self.checkPayment(id, type)

          if (self.counter > 100) {
            self.counter = 0
            clearInterval(self.interval)

            self.$events.$emit('alert', {
              header: self.$t('globals.validation.errors.error'),
              message: 'No reserved payment',
              type: 'error',
              align: 'right'
            })

            if (type === 'booked') {
              self.$router.push({name: 'bookings'})
            } else {
              self.redirect(id, type)
            }
          }
        }, 3000)
      } else {
        this.interval = setInterval(function () {
          self.counter++
          self.checkPayment(id, type)

          if (self.counter > 2) {
            self.counter = 0
            clearInterval(self.interval)

            self.$events.$emit('alert', {
              header: self.$t('globals.validation.errors.error'),
              message: 'No reserved payment',
              type: 'error',
              align: 'right'
            })

            if (type === 'booked') {
              self.$router.push({name: 'bookings'})
            } else {
              self.redirect(id, type)
            }
          }
        }, 3000)
      }
    } else if (operation === 'status') {
      const self = this
      if (process.env.NODE_ENV === 'development') {
        this.interval = setInterval(function () {
          self.counter++
          self.checkStatus(id, type)

          if (self.counter > 100) {
            self.counter = 0
            clearInterval(self.interval)

            self.$events.$emit('alert', {
              header: self.$t('globals.validation.errors.error'),
              message: 'Agreement canceled',
              type: 'error',
              align: 'right'
            })

            if (type === 'booked') {
              self.$router.push({name: 'bookings'})
            } else if (type === 'waitlistsubscriptions') {
              self.$router.push({name: 'wait_list'})
            } else {
              self.$router.push({name: 'dashboard'})
            }
          }
        }, 3000)
      } else {
        this.interval = setInterval(function () {
          self.counter++
          self.checkStatus(id, type)

          if (self.counter > 2) {
            self.counter = 0
            clearInterval(self.interval)

            self.$events.$emit('alert', {
              header: self.$t('globals.validation.errors.error'),
              message: 'Agreement canceled',
              type: 'error',
              align: 'right'
            })

            if (type === 'booked') {
              self.$router.push({name: 'bookings'})
            } else if (type === 'waitlistsubscriptions') {
              self.$router.push({name: 'wait_list'})
            } else {
              self.$router.push({name: 'dashboard'})
            }
          }
        }, 5000)
      }
    } else if (operation === 'overdue_fee') {
      const self = this
      if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local') {
        this.interval = setInterval(function () {
          self.counter++
          self.checkOverdueFeeCompleted(id, type)

          if (self.counter > 100) {
            self.counter = 0
            clearInterval(self.interval)

            self.$events.$emit('alert', {
              header: self.$t('globals.validation.errors.error'),
              message: self.$t('globals.validation.errors.overdue_fee_payment_failed'),
              type: 'error',
              align: 'right'
            })

            self.$router.push({name: 'dashboard'})
          }
        }, 3000)
      } else {
        this.interval = setInterval(function () {
          self.counter++
          self.checkOverdueFeeCompleted(id, type)

          if (self.counter > 2) {
            self.counter = 0
            clearInterval(self.interval)

            self.$events.$emit('alert', {
              header: self.$t('globals.validation.errors.error'),
              message: self.$t('globals.validation.errors.overdue_fee_payment_failed'),
              type: 'error',
              align: 'right'
            })

            self.$router.push({name: 'dashboard'})
          }
        }, 5000)
      }
    } else if (operation === 'startup_fee') {
      const self = this
      if (process.env.NODE_ENV === 'development') {
        this.interval = setInterval(function () {
          self.counter++
          self.checkStartupFeeCompletedTransaction(id, type)

          if (self.counter > 100) {
            self.counter = 0
            clearInterval(self.interval)
            self.$router.push({name: 'bookings'})
          }
        }, 3000)
      } else {
        this.interval = setInterval(function () {
          self.counter++
          self.checkStartupFeeCompletedTransaction(id, type)

          if (self.counter > 2) {
            self.counter = 0
            clearInterval(self.interval)
            self.$router.push({name: 'bookings'})
          }
        }, 5000)
      }
    }
  },

  methods: {
    checkPayment (id, container) {
      this.getExistingReservedPayment(id, container).then((response) => {
        if (response.status === 200) {
          // reserved payment exists
          // activate booked
          clearInterval(this.interval)

          if (container === 'booked') {
            this.activateBooked(id).then((response) => {
              this.$events.$emit('booking-reserved', response.data.data)

              this.$events.$emit('alert', {
                header: this.$t('globals.validation.success.success'),
                message: this.$t('pages.bookings.validation.success.booking_paid'),
                type: 'success',
                align: 'right'
              })

              setTimeout(() => {
                this.$router.push({name: 'bookings'})
              }, 3000)
            })
          } else {
            this.activateSubscriptionOrWaitlist(id, container).then((response) => {
              if (response.status === 201) {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.errors.error'),
                  message: 'There was an error creating payment. Please contact merchant!',
                  type: 'error',
                  align: 'right'
                })

                if (container === 'subscriptions') {
                  setTimeout(() => {
                    this.$router.push({name: 'dashboard'}, () => {
                      this.$router.go()
                    })
                  }, 3000)
                } else {
                  this.$router.push({name: 'wait_list'},
                    () => {
                      this.$router.go()
                    }
                  )
                }
              } else {
                let message
                if (container === 'subscriptions') {
                  message = this.$t('modals.newsubscriptionmodal.validation.nets.success.subscription_added')
                } else {
                  message = this.$t('modals.newwaitlistmodal.validation.success.waitlist_added')
                }

                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.success.success'),
                  message: message,
                  type: 'success',
                  align: 'right'
                })

                setTimeout(() => {
                  this.redirect(response.data.id, container)
                }, 3000)
              }
            }).catch((error) => {
              if (error.response.data.message) {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.errors.error'),
                  message: error.response.data.message,
                  type: 'error',
                  align: 'right'
                })
              }
              setTimeout(() => {
                this.$router.push({name: 'dashboard'})
              }, 3000)
            })
          }
        } else {
          console.log('Reserved payment does not exist')
        }
      })
    },

    checkOverdueFeeCompleted (id, container) {
      this.axios.get(`${container}/${id}/overdue/fee/completed`).then((response) => {
          if (response.data.transaction_exists) {
            clearInterval(this.interval)

            this.$events.$emit('alert', {
              header: this.$t('globals.validation.success.success'),
              message: this.$t('globals.validation.success.overdue_fee_payment_successful'),
              type: 'success',
              align: 'right'
            })
            setTimeout(() => {
              this.$router.push({name: 'subscriptiondashboard', params: {subscriptionId: id}},
                () => {
                  this.$router.go()
                }
              )
            }, 3000)
          }
      })
    },

    checkStartupFeeCompletedTransaction (id, container) {
      this.axios.get(`${container}/${id}/transactions/startup-fee`).then((response) => {
        if (response.status === 200) {
          clearInterval(this.interval)

          this.activateBooked(id).then((response) => {
            this.$events.$emit('booking-reserved', response.data.data)

            this.$events.$emit('alert', {
              header: this.$t('globals.validation.success.success'),
              message: this.$t('pages.bookings.validation.success.booking_added_paid', {payment_time: moment(response.data.data.payment_time.date).format('YYYY-MM-DD HH:mm:ss')}),
              type: 'success',
              align: 'right'
            })

            setTimeout(() => {
              this.$router.push({name: 'bookings'})
            }, 3000)
          }).catch((error) => {
            if (error.response.data.message) {
              this.$events.$emit('alert', {
                header: this.$t('globals.validation.errors.error'),
                message: error.response.data.message,
                type: 'error',
                align: 'right'
              })
            }
            setTimeout(() => {
              this.$router.push({name: 'bookings'})
            }, 3000)
          })
        }
      })
    },

    checkStatus (id, container) {
      this.axios.get(`${container}/${id}/status`).then((response) => {
        if (response.data.status === 'active') {
          clearInterval(this.interval)

          this.$events.$emit('alert', {
            header: this.$t('globals.validation.success.success'),
            message: this.$t('globals.validation.success.overdue_payment_successful'),
            type: 'success',
            align: 'right'
          })

          setTimeout(() => {
            this.redirect(response.data.id, container)
          }, 3000)
        }

        if (response.data.status === 'pending') {
          clearInterval(this.interval)

          this.$events.$emit('alert', {
            header: this.$t('globals.validation.success.success'),
            message: 'Agreement accepted',
            type: 'success',
            align: 'right'
          })

          if (container === 'booked') {
            this.activateBooked(id).then((response) => {
              if (response.status === 201) {
                if (process.env.NODE_ENV === 'development') {
                  setTimeout(() => {
                    this.$router.push({
                      name: 'mobile_pay_success',
                      query: {
                        id: id,
                        type: 'booked',
                        op: response.data.op
                      }
                    })
                  }, 3000)
                } else {
                  window.location.href = response.data.link.href
                }
              } else {
                this.$events.$emit('booking-reserved', response.data.data)

                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.success.success'),
                  message: this.$t('pages.bookings.validation.success.booking_paid'),
                  type: 'success',
                  align: 'right'
                })

                setTimeout(() => {
                  this.$router.push({name: 'bookings'})
                }, 3000)
              }
            }).catch((error) => {
              if (error.response.data.message) {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.errors.error'),
                  message: error.response.data.message,
                  type: 'error',
                  align: 'right'
                })
              }
              setTimeout(() => {
                this.$router.push({name: 'bookings'})
              }, 3000)
            })
          } else {
            this.activateSubscriptionOrWaitlist(id, container).then((response) => {
              if (response.status === 201) {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.errors.error'),
                  message: 'There was an error creating payment. Please contact merchant!',
                  type: 'error',
                  align: 'right'
                })

                if (container === 'subscriptions') {
                  setTimeout(() => {
                    this.$router.push({name: 'dashboard'}, () => {
                      this.$router.go()
                    })
                  }, 3000)
                } else {
                  this.$router.push({name: 'wait_list'},
                    () => {
                      this.$router.go()
                    }
                  )
                }
              } else {
                let message
                if (container === 'subscriptions') {
                  message = this.$t('modals.newsubscriptionmodal.validation.nets.success.subscription_added')
                } else {
                  message = this.$t('modals.newwaitlistmodal.validation.success.waitlist_added')
                }

                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.success.success'),
                  message: message,
                  type: 'success',
                  align: 'right'
                })

                setTimeout(() => {
                  this.redirect(response.data.id, container)
                }, 3000)
              }
            }).catch((error) => {
              if (error.response.data.message) {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.errors.error'),
                  message: error.response.data.message,
                  type: 'error',
                  align: 'right'
                })
              }
              setTimeout(() => {
                this.$router.push({name: 'dashboard'})
              }, 3000)
            })
          }
        }

        if (response.data.status === 'unset') {
          clearInterval(this.interval)

          this.$events.$emit('alert', {
            header: this.$t('globals.validation.errors.error'),
            message: 'Agreement rejected.',
            type: 'error',
            align: 'right'
          })

          setTimeout(() => {
            this.$router.push({name: 'dashboard'})
          }, 3000)
        }
      }).catch((error) => {
        if (error.response.data.message) {
          this.$events.$emit('alert', {
            header: this.$t('globals.validation.errors.error'),
            message: error.response.data.message,
            type: 'error',
            align: 'right'
          })
        }
        this.$router.push({name: 'dashboard'})
      })
    },

    getExistingReservedPayment (bookedId, container) {
      return new Promise((resolve, reject) => {
        this.axios.get(`/${container}/${bookedId}/one-off?status=reserved`)
          .then((response) => {
            resolve(response)
          }).catch((error) => {
          reject(error)
        })
      })
    },

    activateBooked (bookedId) {
      return new Promise((resolve, reject) => {
        this.axios.put(`/booked/${bookedId}/activate`)
          .then((response) => {
            resolve(response)
          }).catch((error) => {
          reject(error)
        })
      })
    },

    activateSubscriptionOrWaitlist (id, container) {
      return new Promise((resolve, reject) => {
        this.axios.put(`${container}/${id}/activate`)
          .then((response) => {
            resolve(response)
          }).catch((error) => {
          reject(error)
        })
      })
    },

    redirect (id, container) {
      this.isLoading = false
      if (container === 'subscriptions') {
        this.$router.push({name: 'subscriptiondashboard', params: { subscriptionId: id }},
          () => {
            this.$router.go()
          }
        )
      } else {
        this.$router.push({name: 'wait_list'},
          () => {
            this.$router.go()
          }
        )
      }
    }
  }
}
</script>

<style scoped>
.thank-you-text {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/payment/mobilepay/Success.vue